import { useEffect } from 'react';

const Heading = (headingRef) => {
  useEffect(() => {
    const heading = "Hi,-I'm Irenee Iradukunda,web Developer";
    const headingLetters = heading.split('');

    headingRef.current.innerHTML = '';

    headingLetters.forEach((letter, ind) => {
      if (letter === '-') {
        headingRef.current.innerHTML += '<br>';
        letter = '';
      }  
      const span = document.createElement('span');
      span.textContent = letter;
      span.classList.add('letter');
      headingRef.current.appendChild(span);
    });
  }, [headingRef]);

  return null;
};

export default Heading;
